export default {
    placeholder: true,
    config: {},
    default: {},
    unique: [],
    lang: {
        name: 'Dynamic Placeholder',
        category: ['BGG', 'Game', 'User', 'Collection', 'Ratings', 'Plays'],
        description: 'Placeholder to insert any applicable fields for the current sorting/filtering rules.',
        views: ['list', 'sheet', 'grid'],
    }
}